import { useDispatch, useSelector } from 'react-redux';
import { NavLink, Link } from 'react-router-dom';

import { logout } from '../../actions/auth';

const NavbarSesion = () => {

    const dispatch = useDispatch();

    const { permisos } = useSelector(state => state.auth.usuario);

    const handleLogout = () => {
        dispatch(logout());
    }

    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
            <div className="container-fluid">
                <div className="w-100">
                    <Link className='navbar-brand' to='/dashboard'>
                        <img src={process.env.REACT_APP_PUBLIC_ROUTE + '/assets/images/logo/isotipo-blanco.png'} alt="logo" height="35" style={{ marginRight: '0.5rem', verticalAlign: 'baseline' }} />
                    </Link>
                    <button className="navbar-toggler float-end" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                </div>
                <div className="collapse navbar-collapse d-lg-flex justify-content-lg-center px-3" id="navbarNavDropdown">
                    <ul className="navbar-nav text-right">
                        <li className="nav-item">
                            <NavLink className={'nav-link'} style={{ whiteSpace: 'nowrap' }} to='/dashboard'>Inicio</NavLink>
                        </li>
                        {
                            permisos?.asesorias?.ver ?
                                <li className="nav-item"><NavLink className={'nav-link'} style={{ whiteSpace: 'nowrap' }} to='/asesorias'>Asesorías</NavLink></li>
                            :
                                null
                        }
                        {
                            permisos?.asesor?.ver ?
                                <li className="nav-item"><NavLink className={'nav-link'} style={{ whiteSpace: 'nowrap' }} to='/mi-asesor'>Mi asesor</NavLink></li>
                            :
                                null
                        }
                        {
                            permisos?.membresia?.ver ?
                                <li className="nav-item"><NavLink className={'nav-link'} style={{ whiteSpace: 'nowrap' }} to='/membresia'>Membresía</NavLink></li>
                            :
                                null
                        }
                        {
                            permisos?.expediente?.ver ?
                                <li className="nav-item"><NavLink className={'nav-link'} style={{ whiteSpace: 'nowrap' }} to='/expediente'>Expediente</NavLink></li>
                            :
                                null
                        }
                        <li className="nav-item dropdown mr-3">
                            <a className={'nav-link dropdown-toggle'} href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Configuración
                            </a>
                            <ul className="dropdown-menu dropdown-menu-dark dropdown-menu-end" aria-labelledby="navbarDropdownMenuLink">
                                {
                                    permisos?.configuracion?.perfil_personal?.ver ?
                                        <li><NavLink className={'dropdown-item'} to='/configuracion/perfil_personal'>Perfil personal</NavLink></li>
                                    :
                                        null
                                }
                                {
                                    permisos?.configuracion?.perfil_empresarial?.ver ?
                                        <li><NavLink className={'dropdown-item'} to='/configuracion/perfil_empresarial'>Perfil empresarial</NavLink></li>
                                    :
                                        null
                                }
                                {
                                    permisos?.configuracion?.metodo_pago?.ver ?
                                        <li><NavLink className={'dropdown-item'} to='/configuracion/metodo_pago'>Método de pago</NavLink></li>
                                    :
                                        null
                                }
                                <li><a className="dropdown-item" onClick={handleLogout} href="/login">Cerrar sesión</a></li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}

export default NavbarSesion;